<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('permits.permits') }}: {{ productName }}</h1>
      <div class="details-component__header_right">
        <!--<a class="link">{{ $t('permits.add_permit') }} <i class="icon icon--plus"></i></a>-->
      </div>
    </div>
    <div class="details-component__content content">
      <v-client-table :data="permits" :columns="columns" :options="options"></v-client-table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ClientTable } from 'vue-tables-2';
import 'styles/vue-table.scss';
import * as mTypes from 'store/mutation-types';

Vue.use(ClientTable);

export default {
  components: {
  },
  computed: mapGetters({
    productName: 'products/product/name',
    permits: 'products/permits/permits',
    user: 'user/user/user',
  }),
  watch: {
    $route: 'fetchPermits',
  },
  route: {
    canReuse: true,
  },
  created() {
    this.fetchPermits();
  },
  methods: {
    fetchPermits() {
      if (this.$route.params.id) {
        this.$store.dispatch('products/permits/fetch', { id: this.$route.params.id, user: this.user });
      } else {
        this.$store.commit(`products/permits/${mTypes.CLEAR_STATE}`);
      }
    },
    routeToUser(permit) {
      this.$router.push({ name: 'user', params: { id: permit.userId } });
    },
  },
  data() {
    return {
      columns: ['parkingCardNr', 'name', 'phone', 'vehicle', 'edit'],
      options: {
        filterable: false,
        rowClassCallback: () => 'VueTables__row',
        perPage: 10,
        texts: {
          noResults: this.$t('tables.noRecords'),
          count: this.$t('tables.count'),
        },
        headings: {
          parkingCardNr: () => this.$t('permits.card_nr'),
          name: () => this.$t('common.name'),
          phone: () => this.$t('common.phone'),
          vehicle: () => this.$t('permits.reg_nr'),
          edit: () => (''),
        },
        templates: {
          name: (h, row) => (
            <a class="link" on-click={ () => this.routeToUser(row) }>
              <span>{row.name}</span>
            </a>
          ),
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/products/Permits.vue